import vtkCleanPolyData from './CleanPolyData';
import vtkCutter from './Cutter';
import vtkPolyDataNormals from './PolyDataNormals';
import vtkThresholdPoints from './ThresholdPoints';

export default {
  vtkCleanPolyData,
  vtkCutter,
  vtkPolyDataNormals,
  vtkThresholdPoints,
};
